// export const BASE_API_URL = "https://ab3104da-1df2-4e12-86fc-f210347fa43e.mock.pstmn.io/api/";
// export const BASE_API_URL = "http://127.0.0.1:8080/api";
export const BASE_API_URL = "https://mindmelt-api.azurewebsites.net";
// export const BASE_API_URL = "http://localhost:5001";

// export const BASE_API_URL = "https://localhost:7220";